import type { MapLayer } from "../redux/global-map.types"

// One prefix per map layer, matching the ids `/features` emits
// (`aggregation.py`): `p:`/`l:` for the two record entities, `s:`/`a:` for
// the Subcontractor/Appointment marker layers.
const PREFIX_TO_ENTITY: Record<string, MapLayer> = {
  p: "project",
  l: "lead",
  s: "subcontractor",
  a: "appointment"
}
const ENTITY_TO_PREFIX: Record<MapLayer, string> = {
  project: "p",
  lead: "l",
  subcontractor: "s",
  appointment: "a"
}

export function parseFeatureId(featureId: string): {
  entityType: MapLayer
  id: string
} {
  const [prefix, ...rest] = featureId.split(":")
  const entityType = PREFIX_TO_ENTITY[prefix]
  if (!entityType) {
    throw new Error(`Unrecognized feature id prefix: ${featureId}`)
  }
  return { entityType, id: rest.join(":") }
}

// The inverse of `parseFeatureId` — a search result comes back as a bare
// uuid (`ProjectQuickView`/`LeadQuickView`'s own `id`, same shape the quick
// view detail endpoints already use), but `selectFeature`/`?feature=` both
// key on the namespaced form `data.features` itself uses.
export function buildFeatureId(entityType: MapLayer, id: string): string {
  return `${ENTITY_TO_PREFIX[entityType]}:${id}`
}
